module.exports = __webpack_public_path__ + "static/media/repeat_case.a19ad55b.svg";